import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { ConfirmPaymentParam } from "features/stock-ordering/core/stock-ordering.params";
import {
  ConfirmPaymentRepository,
  PaymentActionResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum ConfirmPaymentState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: ConfirmPaymentState;
  message: string;
}

const initialState: InitialState = {
  status: ConfirmPaymentState.initial,
  message: "",
};

export const confirmPayment = createAsyncThunk(
  "confirmPayment",
  async (param: ConfirmPaymentParam, { rejectWithValue }) => {
    try {
      const response: PaymentActionResponse =
        await ConfirmPaymentRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  },
);

export const confirmPaymentSlice = createSlice({
  name: "confirmPayment",
  initialState,
  reducers: {
    resetConfirmPayment: (state) => {
      state.status = ConfirmPaymentState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(confirmPayment.pending, (state) => {
        state.status = ConfirmPaymentState.inProgress;
      })
      .addCase(confirmPayment.fulfilled, (state, action) => {
        if (action.payload) {
          state.status = ConfirmPaymentState.success;
          state.message = action.payload.message;
        }
      })
      .addCase(confirmPayment.rejected, (state, action) => {
        state.status = ConfirmPaymentState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectConfirmPayment = (state: RootState) => state.confirmPayment;
export const { resetConfirmPayment } = confirmPaymentSlice.actions;
export default confirmPaymentSlice.reducer;
